import { render, staticRenderFns } from "./LanguageEditForm.vue?vue&type=template&id=27e34aa2&scoped=true"
import script from "./LanguageEditForm.vue?vue&type=script&lang=js"
export * from "./LanguageEditForm.vue?vue&type=script&lang=js"
import style0 from "./LanguageEditForm.vue?vue&type=style&index=0&id=27e34aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e34aa2",
  null
  
)

export default component.exports